import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-chest-header.png';
import ChestNotificationView from '../../components/ChestReward/ChestReward';
import { ActionType, FormatType } from '../../enums';

import {
  TXTCLI_YouXve_been_awarded_a_ChestX,
  TXTMOB_AvailableX,
  TXTWCL_View_all_Chests
} from './ChestReward.timelocked.config.messages.json';

export default {
  front: {
    view: ChestNotificationView,
    viewConfig: {
      title: { tag: TXTCLI_YouXve_been_awarded_a_ChestX },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      desktopWidth: 470,
      desktopHeight: 480,
      isGridStyled: false,
      displayAttributes: [
        {
          attrKey: 'availableOn',
          attrLabel: { tag: TXTMOB_AvailableX },
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTWCL_View_all_Chests },
          href: '/account/my-stars/chest-inventory',
          actionFunction: ({ notificationId }: ActionParams) =>
            dispatch.notification.delete({ notificationId })
        }
      ]
    }
  }
};
